import React, { useState, useRef, useEffect } from 'react';
import { CaretDown } from '@phosphor-icons/react';
import { useCurrency, CURRENCY_META } from '../context/CurrencyContext';

const ORDER = ['USD', 'INR', 'EUR', 'GBP', 'JPY', 'HKD', 'CAD', 'AUD'];

const CurrencyPicker = ({ compact = false }) => {
  const { displayCcy, setDisplayCcy, meta } = useCurrency();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const pick = (code) => {
    setDisplayCcy(code);
    setOpen(false);
  };

  return (
    <div className="relative" ref={wrapRef}>
      <button
        type="button"
        onClick={() => setOpen((s) => !s)}
        className={`flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 text-zinc-200 transition-colors ${
          compact ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm'
        }`}
        data-testid="currency-picker-button"
        aria-label={`Display currency: ${displayCcy}`}
      >
        <span aria-hidden>{meta.flag}</span>
        <span className="font-semibold">{displayCcy}</span>
        <CaretDown size={12} weight="bold" className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div
          className="absolute right-0 mt-2 min-w-[180px] rounded-xl border border-white/10 bg-zinc-950/95 backdrop-blur-md shadow-xl py-1 z-50"
          data-testid="currency-picker-menu"
        >
          <div className="px-3 py-1.5 text-[10px] uppercase tracking-wider text-zinc-500">Display prices in</div>
          {ORDER.map((code) => {
            const m = CURRENCY_META[code];
            const active = code === displayCcy;
            return (
              <button
                key={code}
                type="button"
                onClick={() => pick(code)}
                className={`w-full flex items-center justify-between px-3 py-1.5 text-sm transition-colors ${
                  active ? 'bg-gold/15 text-gold' : 'text-zinc-200 hover:bg-white/5'
                }`}
                data-testid={`currency-option-${code}`}
              >
                <span className="flex items-center gap-2">
                  <span aria-hidden>{m.flag}</span>
                  <span className="font-semibold">{code}</span>
                  <span className="text-zinc-500 text-xs">{m.symbol}</span>
                </span>
                {active && <span className="text-gold text-xs">●</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CurrencyPicker;
